import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./navbar.css"; // Add custom styling if needed

export default function NavBar({ setActiveOperation }) {
  const navigate = useNavigate();

  return (
    <nav className="navbar bg-dark p-2">
      <div className="btn-group">
        <button onClick={() => { setActiveOperation("file"); navigate("/"); }} className="btn btn-light">File</button>
        <button onClick={() => setActiveOperation("edit")} className="btn btn-light">Edit</button>
        <button onClick={() => setActiveOperation("image")} className="btn btn-light">Image</button>
        <button onClick={() => setActiveOperation("settings")} className="btn btn-light">Settings</button>
        <button onClick={() => setActiveOperation("output")} className="btn btn-light">Output</button>
        <Link to="/map" className="btn btn-light">Map</Link>
      </div>
    </nav>
  );
}
